module.exports = __webpack_public_path__ + "img/delete-dark.85eb9ca2.svg";